"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NowportsChileSpa = void 0;
exports.NowportsChileSpa = {
    id: 'nowportsChileSpa',
    companyName: 'Nowports Chile Spa',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'nowportsChileSpa',
    },
    isInternal: false,
    isActive: true,
    countries: ['CL'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTm93cG9ydHNDaGlsZVNwYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9Ob3dwb3J0c0NoaWxlU3BhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsZ0JBQWdCLEdBQVU7SUFDbkMsRUFBRSxFQUFFLGtCQUFrQjtJQUN0QixXQUFXLEVBQUUsb0JBQW9CO0lBQ2pDLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUsa0JBQWtCO0tBQzVCO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9